var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tip==1)?_c('div',{staticClass:"box",on:{"click":_vm.tipHide}},[_c('em',{staticClass:"icon part_start"}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btngroup"},[_c('a',{staticClass:"btn btn_start",attrs:{"href":"javascript:;"}},[_vm._v("点击鼠标开始测试")])])
}]

export { render, staticRenderFns }